import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useGetProjectsQuery } from "../../features/api/Projects/projectsApi";
import { checkedProjects } from "../../features/api/Projects/projectsSlice";
import { useGetTeamMembersQuery } from "../../features/api/teamMembers/teamMembersApi";
import Projects from "./Projects";
import TeamMembers from "./TeamMembers";

export default function Sidebar() {
  const dispatch = useDispatch();
  const {
    data: teamMembers,
    isLoading,
    isError,
    error,
  } = useGetTeamMembersQuery() || {};
  const {
    data: projects,
    isLoading: projectIsLoading,
    isError: projectIsError,
    error: projectError,
  } = useGetProjectsQuery() || {};

  useEffect(() => {
    if (projects && projects.length > 0) {
      projects.forEach((project) => {
        dispatch(checkedProjects({ project, checked: true }));
      });
    }
  }, [dispatch, projects]);

  let teamContent = null;

  if (isLoading) {
    teamContent = <div className="mt-3 space-y-4">Loading...</div>;
  } else if (!isLoading && isError) {
    teamContent = <div className="mt-3 space-y-4">{error?.data} </div>;
  } else if (!isLoading && !isError && teamMembers?.length === 0) {
    teamContent = <div className="mt-3 space-y-4">No team members found!</div>;
  } else if (!isLoading && !isError && teamMembers?.length > 0) {
    teamContent = teamMembers?.map((member) => {
      return <TeamMembers key={member?.id} member={member} />;
    });
  }

  let projectsContent = null;

  if (projectIsLoading) {
    projectsContent = <div className="mt-3 space-y-4">Loading...</div>;
  } else if (!projectIsLoading && projectIsError) {
    projectsContent = (
      <div className="mt-3 space-y-4">{projectError?.data} </div>
    );
  } else if (!projectIsLoading && !projectIsError && projects?.length === 0) {
    projectsContent = (
      <div className="mt-3 space-y-4">No team members found!</div>
    );
  } else if (!projectIsLoading && !projectIsError && projects?.length > 0) {
    projectsContent = projects?.map((project) => {
      return <Projects key={project?.id} project={project} />;
    });
  }

  return (
    <div className="sidebar">
      {/* <!-- Projects List --> */}
      <div>
        <h3 className="text-xl font-bold">Projects</h3>
        <div className="mt-3 space-y-4">{projectsContent}</div>
      </div>

      {/* <!-- Team Members --> */}
      <div className="mt-8">
        <h3 className="text-xl font-bold">Team Members</h3>
        <div className="mt-3 space-y-4">{teamContent}</div>
      </div>
    </div>
  );
}
